import { customElement } from 'lit/decorators/custom-element.js';
import { container } from 'tsyringe';
import { AbstractStandardTimelineView } from '../abstract-standard-timeline.view';
import type { TimelineViewConfig } from '../_shared/timeline-view.config';
import { ProjectRepository } from '../../domain/repositories/project.repository';
import type { Issue } from '../../domain/entities/issue.entity';

/** Filters Y-axis to show only daily-type projects (ProjectType.key = 'daily-work'). */
const VIEW_CONFIG: TimelineViewConfig = {
    entityType: 'Project',
    sort: { strategy: 'property', path: 'title', direction: 'ASC' },
    yItemPath: 'project.uid',
    includes: ['project', 'employees', 'keywords', 'creator', 'employeeToIssueAssignments'],
    queryParams: [{ key: 'type.key', comparator: 'eq', value: 'daily-work' }]
};

/**
 * Timeline view grouping issues by daily project.
 * Route: /by-daily
 *
 * Y-axis: Project — overrides populateTemplateFromYAxis to assign project.
 */
@customElement('o2d-dailys-view')
export class DailysView extends AbstractStandardTimelineView {
    protected readonly viewStateName = 'dailys';
    protected readonly viewConfig = VIEW_CONFIG;

    /** Assigns clicked project to template issue. */
    protected override async populateTemplateFromYAxis(template: Issue, yAxisUid: string): Promise<void> {
        const projectRepo = container.resolve(ProjectRepository);
        const project = await projectRepo.findOneById(yAxisUid);
        if (project) {
            template.project = project;
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'o2d-dailys-view': DailysView;
    }
}
